import { EndScreenCase } from "@/components/endScreens";
import { NewIntakeLayout } from "@/layout";
import { PATIENT_STATUS } from "@/utils";

export const EndScreenRegistered = () => {
  return (
    <NewIntakeLayout isEndScreen>
      <EndScreenCase
        status={PATIENT_STATUS.ACTIVE}
        title={"Patient has been successfully registered"}
        description={`Our staff will contact them shortly to process their order.`}
      />
    </NewIntakeLayout>
  );
};
